//redux 
//state-Ui-action-reducer-store 
//Here to simply written actions 

export const ADD_TO_CART = 'ADD_TO_CARD' ;
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const LOAD_CURRENT_ITEM =  'LOAD_CURRENT_ITEM';
export const UPDATE_QTY = 'UPDATE_QTY';

